(() => {
  const MOBILE_QUERY = window.matchMedia('(max-width: 989px)');

  let overlayForm = null;
  let openingFrame = null;
  let lastTrigger = null;
  let savedBodyOverflow = '';
  let savedBodyPaddingRight = '';

  function removeFilterParameters(url) {
    const keys = Array.from(url.searchParams.keys());

    keys.forEach(key => {
      if (key.startsWith('filter.') || key === 'page') {
        url.searchParams.delete(key);
      }
    });
  }

  function buildFilterUrl(form) {
    const url = new URL(window.location.href);
    const formData = new FormData(form);

    removeFilterParameters(url);

    const groupedValues = new Map();

    for (const [key, rawValue] of formData.entries()) {
      const value = String(rawValue).trim();

      if (!value) continue;

      if (!groupedValues.has(key)) {
        groupedValues.set(key, []);
      }

      groupedValues.get(key).push(value);
    }

    groupedValues.forEach((values, key) => {
      url.searchParams.delete(key);

      values.forEach(value => {
        url.searchParams.append(key, value);
      });
    });

    const filterGroup = form.querySelector('[data-stockops-collection-base]');
    if (filterGroup) {
      const base = filterGroup.dataset.stockopsCollectionBase;
      if (base && url.pathname.startsWith(base)) {
        const tail = url.pathname.slice(base.length).replace(/^\//, '');
        const others = tail ? tail.split('+').filter(tag => tag && !tag.startsWith('stockops-filter-')) : [];
        const selected = [...filterGroup.querySelectorAll('a[data-stockops-filter-handle][aria-pressed="true"]')]
          .map(a => a.dataset.stockopsFilterHandle).filter(Boolean);
        const tags = [...new Set([...others, ...selected])];
        url.pathname = base + (tags.length ? '/' + tags.join('+') : '');
      }
    }
    return url;
  }

  function remapCloneIds(root) {
    const idMap = new Map();

    root.querySelectorAll('[id]').forEach((element, index) => {
      const oldId = element.id;
      const newId = `IBMobileFilter-${index}-${oldId}`;

      idMap.set(oldId, newId);
      element.id = newId;
    });

    root.querySelectorAll('[for]').forEach(label => {
      const oldFor = label.getAttribute('for');

      if (idMap.has(oldFor)) {
        label.setAttribute('for', idMap.get(oldFor));
      }
    });

    ['aria-labelledby', 'aria-controls', 'aria-describedby'].forEach(attribute => {
      root.querySelectorAll(`[${attribute}]`).forEach(element => {
        const remapped = element
          .getAttribute(attribute)
          .split(/\s+/)
          .map(value => idMap.get(value) || value)
          .join(' ');

        element.setAttribute(attribute, remapped);
      });
    });
  }

  function createOverlayForm() {
    const desktopForm = document.getElementById('FacetFiltersForm');

    if (!desktopForm) return null;

    const clone = desktopForm.cloneNode(true);

    clone.removeAttribute('id');
    clone.classList.add('ib-mobile-filter-clone-form');
    clone.setAttribute('data-ib-mobile-filter-clone', 'true');
    remapCloneIds(clone);

    return clone;
  }

  function initialise() {
    const overlay = document.getElementById('ib-mobile-filter-overlay');
    if (!overlay) return;

    const body = overlay.querySelector('.ib-mobile-filter-body');
    const closeButton = overlay.querySelector('.ib-mobile-filter-close');
    const applyButton = overlay.querySelector('.ib-mobile-filter-apply');
    const clearButton = overlay.querySelector('.ib-mobile-filter-clear');

    function mountOverlayForm() {
      if (overlayForm) return true;

      overlayForm = createOverlayForm();
      if (!overlayForm) return false;

      body.replaceChildren(overlayForm);
      return true;
    }

    function unmountOverlayForm() {
      overlayForm?.remove();
      overlayForm = null;
      body.replaceChildren();
    }

    function lockPage() {
      savedBodyOverflow = document.body.style.overflow;
      savedBodyPaddingRight = document.body.style.paddingRight;

      const scrollbarWidth = Math.max(
        0,
        window.innerWidth - document.documentElement.clientWidth
      );

      document.body.classList.add('ib-filter-open');
      document.body.style.overflow = 'hidden';

      if (scrollbarWidth > 0) {
        document.body.style.paddingRight = `${scrollbarWidth}px`;
      }
    }

    function unlockPage() {
      document.body.classList.remove('ib-filter-open');
      document.body.style.overflow = savedBodyOverflow;
      document.body.style.paddingRight = savedBodyPaddingRight;
    }

    function closeNativeDisclosure(trigger) {
      const disclosure = trigger?.closest('details.mobile-facets__disclosure');
      if (!disclosure) return;

      disclosure.classList.remove('menu-opening');
      disclosure.removeAttribute('open');
    }

    function hideOverlay({ returnFocus = true } = {}) {
      if (openingFrame !== null) {
        cancelAnimationFrame(openingFrame);
        openingFrame = null;
      }

      overlay.classList.remove('active', 'ib-filter-preparing');
      overlay.setAttribute('aria-hidden', 'true');
      unmountOverlayForm();
      unlockPage();

      if (
        returnFocus &&
        lastTrigger &&
        document.contains(lastTrigger)
      ) {
        lastTrigger.focus({ preventScroll: true });
      }

      lastTrigger = null;
    }

    function openOverlay(event, trigger) {
      if (!MOBILE_QUERY.matches) return;

      event?.preventDefault();
      event?.stopImmediatePropagation();

      if (
        overlay.classList.contains('active') ||
        overlay.classList.contains('ib-filter-preparing')
      ) {
        return;
      }

      lastTrigger = trigger || null;
      closeNativeDisclosure(lastTrigger);

      overlay.classList.add('ib-filter-preparing');
      overlay.setAttribute('aria-hidden', 'false');
      lockPage();

      if (!mountOverlayForm()) {
        hideOverlay({ returnFocus: false });
        return;
      }

      void overlay.offsetHeight;

      openingFrame = requestAnimationFrame(() => {
        overlay.classList.remove('ib-filter-preparing');
        overlay.classList.add('active');
        openingFrame = null;
        closeButton?.focus({ preventScroll: true });
      });
    }

    document.addEventListener(
      'click',
      event => {
        if (!MOBILE_QUERY.matches) return;

        const trigger =
          event.target.closest('.mobile-facets__open') ||
          event.target.closest('[href="#FacetFiltersFormMobile"]') ||
          event.target.closest('[aria-controls="FacetFiltersFormMobile"]');

        if (trigger) {
          openOverlay(event, trigger);
        }
      },
      true
    );

    closeButton?.addEventListener('click', () => {
      hideOverlay();
    });

    body.addEventListener('click', event => {
      const link = event.target.closest?.('a[data-stockops-filter-handle]');
      if (!link) return;
      event.preventDefault();
      event.stopPropagation();
      const chosen = link.getAttribute('aria-pressed') === 'true';
      if (!chosen) link.closest('details')?.querySelectorAll('a[data-stockops-filter-handle]').forEach(x => { x.setAttribute('aria-pressed','false'); x.classList.remove('stockops-facet-link--active'); });
      link.setAttribute('aria-pressed',String(!chosen));
      link.classList.toggle('stockops-facet-link--active',!chosen);
    });

    applyButton?.addEventListener('click', () => {
      if (!overlayForm) return;

      const url = buildFilterUrl(overlayForm);
      hideOverlay({ returnFocus: false });
      window.location.assign(url.toString());
    });

    clearButton?.addEventListener('click', () => {
      const url = new URL(window.location.href);

      removeFilterParameters(url);
      const collectionBase = overlayForm?.querySelector('[data-stockops-collection-base]')?.dataset.stockopsCollectionBase;
      if (collectionBase) url.pathname = collectionBase;
      hideOverlay({ returnFocus: false });
      window.location.assign(url.toString());
    });

    overlay.addEventListener('click', event => {
      if (event.target === overlay) {
        hideOverlay();
      }
    });

    document.addEventListener('keydown', event => {
      if (
        event.key === 'Escape' &&
        overlay.getAttribute('aria-hidden') === 'false'
      ) {
        hideOverlay();
      }
    });

    MOBILE_QUERY.addEventListener?.('change', event => {
      if (!event.matches) {
        hideOverlay({ returnFocus: false });
      }
    });

    window.addEventListener('pageshow', () => {
      overlay.classList.remove('active', 'ib-filter-preparing');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('ib-filter-open');
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
      unmountOverlayForm();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }
})();

/* =========================================================
 * Desktop facets submission repair
 *
 * The live desktop form remains untouched. This desktop-only
 * listener submits its current values through the collection URL,
 * so checkbox and price filters work even when Dawn's bound input
 * listener has been lost by previous DOM replacements.
 * ========================================================= */
(() => {
  const DESKTOP_QUERY = window.matchMedia('(min-width: 990px)');
  const FORM_SELECTOR = '#FacetFiltersForm';
  const FILTER_PREFIX = 'filter.';

  let submitTimer = null;

  function buildDesktopFilterUrl(form) {
    const url = new URL(window.location.href);
    const formData = new FormData(form);
    const groupedValues = new Map();

    Array.from(url.searchParams.keys()).forEach(key => {
      if (key.startsWith(FILTER_PREFIX) || key === 'page') {
        url.searchParams.delete(key);
      }
    });

    for (const [key, rawValue] of formData.entries()) {
      const value = String(rawValue).trim();

      if (!value) continue;

      if (!groupedValues.has(key)) {
        groupedValues.set(key, new Set());
      }

      groupedValues.get(key).add(value);
    }

    groupedValues.forEach((values, key) => {
      url.searchParams.delete(key);

      values.forEach(value => {
        url.searchParams.append(key, value);
      });
    });

    return url;
  }

  function submitDesktopFilters(form) {
    const nextUrl = buildDesktopFilterUrl(form);

    if (nextUrl.toString() === window.location.href) return;

    window.location.assign(nextUrl.toString());
  }

  document.addEventListener(
    'input',
    event => {
      if (!DESKTOP_QUERY.matches) return;

      const form = event.target.closest?.(FORM_SELECTOR);
      if (!form) return;

      /* Prevent the stale Dawn listener from also trying to process
         the same interaction. This is scoped to the desktop form only. */
      event.stopImmediatePropagation();

      clearTimeout(submitTimer);
      submitTimer = window.setTimeout(() => {
        submitDesktopFilters(form);
      }, 450);
    },
    true
  );

  document.addEventListener('click', event => {
    if (!DESKTOP_QUERY.matches) return;
    const link = event.target.closest?.('#FacetFiltersForm a[data-stockops-filter-handle]');
    if (!link) return;
    const target = new URL(link.href);
    new URL(window.location.href).searchParams.forEach((value, key) => {
      if ((key.startsWith('filter.') || key === 'sort_by') && !target.searchParams.has(key)) target.searchParams.append(key, value);
    });
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(target.toString());
  }, true);

  document.addEventListener(
    'click',
    event => {
      if (!DESKTOP_QUERY.matches) return;

      const link = event.target.closest?.(
        '#main-collection-filters .active-facets-desktop facet-remove a, ' +
        '#main-collection-filters .active-facets-desktop .active-facets__button-remove, ' +
        '#main-search-filters .active-facets-desktop facet-remove a, ' +
        '#main-search-filters .active-facets-desktop .active-facets__button-remove'
      );

      if (!link) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign(link.href);
    },
    true
  );
})();
